import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    Inject,
    ModelEvents
} from "@denishussar/html5-game-engine";
import {GameModel} from "../../Models/GameModel";
import {GameLogic} from "../../Logic/GameLogic";
import {AdsLogic} from "../../Logic/Ads/AdsLogic";
import {AnalyticsController} from "../../Services/Analytics/AnalyticsController";
import {SavesManager} from "../../Managers/SavesManager";
import {IShopCrazyGamesModalControllerOptions} from "./ShopCrazyGamesModalController";
import {AnimationContents} from "../../../AnimationContents";
import {ITopBarMenuControllerOptions, TopBarMenuController} from "../Screens/TopBarMenuController";
import {LocalizationContents} from "../../LocalizationContents";
import {
    GameEvent,
    GameEventPopupButtonName,
    GameEventPopupName,
    GameEventStoreButtonClick
} from "../../Constants/GameEvent";
import {ButtonController, IButtonControllerOptions} from "../../Common/ButtonController";
import {GreenButtonTextStyle} from "../../Constants/TextStyles";
import {AlbumsLibrary} from "../../Models/AlbumsLibrary";
import {IPictureData} from "../../Services/CloudDB/Contract";
import {Sprite, Texture} from "pixi.js";
import {CatalogIconController, ICatalogIconControllerOptions} from "../Screens/Catalog/CatalogIconController";
import {getSpriteFromUrl} from "../../Common/getSpriteFromUrl";
import {createGreyTexture} from "../../Common/Utils";
import {IPictureTexture} from "../Screens/Catalog/CatalogFolderController";

export interface IFTUEWelcomeModalControllerOptions {

}

export class FTUEWelcomeModalController extends AnimationBaseController {
    $model: GameModel;

    public constructor(
        @Inject private options: IShopCrazyGamesModalControllerOptions,
        @Inject private gameLogic: GameLogic,
        @Inject private adsLogic: AdsLogic,
        @Inject private analytics: AnalyticsController,
        @Inject private saveManager: SavesManager,
        @Inject private modelEvents: ModelEvents,
        @Inject private model: GameModel,
    ) {
        super('FTUEWelcomeModalController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.FTUE_WELCOME_SCREEN_JSON,
            libraryName: 'modal_welcome_screen',
            childControllers: {
                picture_01: {
                    instanceName: 'card_1.button',
                    controller: ButtonController,
                    options: <IButtonControllerOptions>{
                        disabled: false,
                        onClick: (status: boolean) => {
                            const ftuePicture = this.model.albumLibrary.getPictureData(`${AlbumsLibrary.PICTURE_FTUE}1`);

                            localStorage.setItem("FTUE_CHOOSED_IMAGE", '1');
                            this.modelEvents.dispatch(this.$model, GameEvent.popupButtonClick, { popupName: GameEventPopupName.ftueWelcome, buttonName: GameEventPopupButtonName.ftue1 });

                            if (ftuePicture) {
                                this.gameLogic.setPicture(ftuePicture);
                                return;
                            }
                        },
                        label: LocalizationContents.getText('Play'),
                        style: GreenButtonTextStyle,
                    },
                },
                picture_02: {
                    instanceName: 'card_2.button',
                    controller: ButtonController,
                    options: <IButtonControllerOptions>{
                        disabled: false,
                        onClick: (status: boolean) => {
                            const ftuePicture = this.model.albumLibrary.getPictureData(`${AlbumsLibrary.PICTURE_FTUE}2`);
                            this.modelEvents.dispatch(this.$model, GameEvent.popupButtonClick, { popupName: GameEventPopupName.ftueWelcome, buttonName: GameEventPopupButtonName.ftue2 });

                            localStorage.setItem("FTUE_CHOOSED_IMAGE", '2');

                            if (ftuePicture) {
                                this.gameLogic.setPicture(ftuePicture);
                                return;
                            }
                        },
                        label: LocalizationContents.getText('Play'),
                        style: GreenButtonTextStyle,
                    },
                },
                picture_03: {
                    instanceName: 'card_3.button',
                    controller: ButtonController,
                    options: <IButtonControllerOptions>{
                        disabled: false,
                        onClick: (status: boolean) => {
                            const ftuePicture = this.model.albumLibrary.getPictureData(`${AlbumsLibrary.PICTURE_FTUE}3`);
                            this.modelEvents.dispatch(this.$model, GameEvent.popupButtonClick, { popupName: GameEventPopupName.ftueWelcome, buttonName: GameEventPopupButtonName.ftue3 });

                            localStorage.setItem("FTUE_CHOOSED_IMAGE", '3');

                            if (ftuePicture) {
                                this.gameLogic.setPicture(ftuePicture);
                                return;
                            }
                        },
                        label: LocalizationContents.getText('Play'),
                        style: GreenButtonTextStyle,
                    },
                },
            }
        }
    }

    protected onDestroy() {
        super.onDestroy();
    }

    protected onInitialize() {
        this.setTextByQuery('title', LocalizationContents.getText('ftue_title'));
        this.setTextByQuery('sub_title', LocalizationContents.getText('ftue_subtitle'));

        this.createPictures()
            .then(() => {
                console.log("[FTUEWelcomeModalController] Pictures created!")
            })
            .catch((e) => {
                console.error(e);
            })
    }

    protected async createPictures(): Promise<void> {
        const content = new PIXI.Container();
        return this.prepareTextures()
            .then((pictures) => {
                for (let i = 0; i < pictures.length; i++) {
                    const picture = pictures[i].picture as IPictureData;
                    const texture = pictures[i].texture as Texture;

                    const sprite = new Sprite();
                    sprite.texture = texture;

                    const icon = this.getDisplayObjectByQuery(`card_${i+1}`)[0];

                    sprite.anchor.set(sprite.anchor.x, 0.5);
                    sprite.width = 295;
                    sprite.height = 295;
                    sprite.anchor.set(0.5);
                    sprite.x = icon.x;
                    sprite.y = icon.y - 40;

                    this.display.addChild(sprite);
                }
            })
            .catch((e) => {
                console.error("Can't create pictures!")
                throw e;
            })
    }


    protected prepareTextures(): Promise<IPictureTexture[]> {
        const promises: Promise<IPictureTexture>[] = [];
        const pictures: IPictureData[] = [
            this.$model.albumLibrary.getPictureData('FTUE1'),
            this.$model.albumLibrary.getPictureData('FTUE2'),
            this.$model.albumLibrary.getPictureData('FTUE3'),
        ];

        for (let i = 0; i < pictures.length; i++) {
            const picture = pictures[i];
            const save = this.gameLogic.getSave(picture.id);
            let promise: Promise<IPictureTexture>;
            if (save && save.src) {
                promise = new Promise((resolve) => {
                    const texture = PIXI.Texture.from(save.src);

                    const timeout = 100;
                    const size = 1;
                    let timerId = setTimeout(function tick() {
                        if (texture.width > size && texture.height > size) {
                            texture.baseTexture.scaleMode = PIXI.SCALE_MODES.NEAREST;
                            resolve({picture, texture});
                        } else {
                            timerId = setTimeout(tick, timeout);
                        }
                    }, timeout);
                })
                promises.push(promise.catch((e) => {
                    console.error("Error to get! ", save.src);
                    throw e;
                }));
            } else {
                promise = getSpriteFromUrl('assets/' + picture.src, `icon${picture.id}`)
                    .then((res) => {
                        const {sprite, cached} = res;
                        let texture: PIXI.Texture | undefined;
                        if (sprite.texture) {
                            // texture = createGreyTexture(sprite.texture);
                            texture = PIXI.Texture.from('assets/' + picture.src);
                            texture.baseTexture.scaleMode = PIXI.SCALE_MODES.NEAREST;
                        } else {
                            console.error("Do not have a texture!");
                        }

                        return Promise.resolve({picture, texture});
                    })
                    .catch((e) => {
                        console.error("Error to download! ",'assets/' + picture.src);
                        throw e;
                    })

                promises.push(promise);
            }
        }

        return Promise.all(promises);
    }
}